import { usePermissions } from "@Context/common/permissions/permissions";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, OutlinedInputProps, TextFieldProps, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import { StyledTextField } from './styled-components';

const BybTextField = (props: TextFieldProps) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const permissions = usePermissions();
  const isDisabled = permissions?.canEdit === false || !!props.disabled;

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <StyledTextField
      {...props}
      type={props.type === 'password' && showPassword ? 'text' : props.type}
      InputLabelProps={{
        shrink: true,
      }}
      disabled={props.disabled || isDisabled}
      sx={
        !isSmDown
          ? {
              '& .MuiInputBase-root': {
                backgroundColor: props.value ? 'transparent' : 'dsSurface.v200',
              },
              ...props.sx,
            }
          : undefined
      }
      InputProps={
        {
          disableUnderline: true,
          endAdornment: props.type === 'password' && (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                sx={{
                  color: 'dsNeutral.v100',
                }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
          ...props.InputProps,
        } as Partial<OutlinedInputProps>
      }
    />
  );
};

export default BybTextField;
